import {Inject, Injectable} from '@angular/core';
import {LocationModel} from "../../../models/location.model";
import {EntitiesChannel} from "../../classes/entities-channel";

@Injectable({providedIn: 'root'})
export class LocationsChanelService extends EntitiesChannel<LocationModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "locations_changed";
  }
  getPartialChannelName(): String {
    return "locations_partial_changed";
  }

  getCreateChannelName(): String {
    return "";
  }


}
